// extracted by mini-css-extract-plugin
export var editInput = "_iq-0";
export var editInputCompact = "_iq-2";
export var editInputLarge = "_iq-1";
export var editInputSmall = "_iq-3";